import { Messages } from '../../../../codegen/Localize';
import { IScheduleInfo } from '../../../../ts/models/IScheduleInfo';
import { scheduleEdit } from '../../../actions/spaces/ScheduleMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { userCanEditSchedule, containsAccelerationSchedule } from './IEntityActionHelpers';

export const ScheduleEditAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.EditSchedule,
  translateName: Messages.editScheduleSettings_action,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanEditSchedule(state, targetItems) &&
      !containsAccelerationSchedule(targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return targetItems.length === 1;
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleEdit(targetItems)
};
